import wrappedAxios from "../axiosWrapper";
import { HomepagePartitionResponse, NavMenuPartitionResponse } from "./types";

export const fetchNavMenuPartition = () =>
  wrappedAxios<NavMenuPartitionResponse>({
    method: "get",
    url: `/api/Homepage/IndexNavigation`,
  });

export const fetchHomepagePartition = () =>
  wrappedAxios<HomepagePartitionResponse>({
    method: "get",
    url: `/api/Homepage/IndexBody`,
  });
